<div class="app-page-layout">
    <top-notification-bar class="export-hide"></top-notification-bar>

    <div class="app-page-content">
        <router-outlet></router-outlet>
    </div>
</div>
